import styled from '@emotion/styled'

import CenterContainer from '../components/CenterContainer'

import Logo from '../assets/logo.svg'

import { RESULT_DATE } from '../utils/const'
import { observer } from 'mobx-react-lite'
import AuthStore from '../stores/auth'
import { Button } from 'antd'

const LoginLayout = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: 32px;
`

const LoginHeading = styled.h2`
  margin-top: 2em;
  font-weight: bold;
`

function RegistrationClosed() {
  const authStore = AuthStore

  return (
    <CenterContainer>
      <LoginLayout>
        <a href="https://www.ywc.in.th" className="flex justify-center">
          <img src={Logo} alt="YWC Logo" />
        </a>
        <LoginHeading>
          ระบบรับสมัคร Young Webmaster Camp 20
        </LoginHeading>

        <div>
          <h1 className="font-semibold">ระบบปิดรับสมัครแล้ว</h1>
          <p className="my-3">
            โปรดรอประกาศผลการรับสมัครบนเว็บไซต์{' '}
            <a
              href="https://ywc.in.th"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              ywc.in.th
            </a>{' '}
            ในวันที่ {RESULT_DATE}
          </p>
          <p className="mb-8">
            ติดตามข่าวสารและสอบถามข้อมูลเพิ่มเติมได้ทาง{' '}
            <a
              href="https://www.facebook.com/ywcth"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Facebook Page
            </a>
          </p>
          <div className="flex w-full justify-center">
            {!!authStore.userId && (
              <Button onClick={() => authStore.doLogout()}>
                ออกจากระบบ
              </Button>
            )}
          </div>
        </div>
      </LoginLayout>
    </CenterContainer>
  )
}

export default observer(RegistrationClosed)
